import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function LatestBlogSection() {
  const posts = [
  {
    id: 'post_cooking_oils',
    title: "Top 5 Cooking Oils in High Demand for 2026",
    excerpt: "Which cooking oils are food manufacturers buying right now? We break down the top 5 oils leading the market and explain why they're essential for your business.",
    image: "https://images.unsplash.com/photo-1679604129971-0611abd53ff5",
    alt: "Various cooking oil bottles on kitchen counter showing market trends",
    category: "Market Trends",
    date: "February 8, 2026",
    readTime: "5 min read",
    href: "/blog#cooking-oils-2026"
  },
  {
    id: 'post_wood_pellets',
    title: "Sustainable Wood Pellet Sourcing: Best Practices",
    excerpt: "Eco-friendly sourcing is changing the biomass energy industry. Learn what it means for buyers and how to choose sustainable suppliers.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_14c4dd2c1-1768255287690.png",
    alt: "Sustainable wood pellets production facility with eco-friendly practices",
    category: "Sustainability",
    date: "February 5, 2026",
    readTime: "7 min read",
    href: "/blog#wood-pellets-sourcing"
  },
  {
    id: 'post_chicken_feed',
    title: "How to Choose Quality Chicken Feed for Your Farm",
    excerpt: "Not all chicken feed is created equal. This guide helps you select the right formulation for layers, broilers, and organic operations.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a79c2185-1770939795268.png",
    alt: "Chicken feed selection guide showing different feed types",
    category: "Agriculture",
    date: "February 1, 2026",
    readTime: "6 min read",
    href: "/blog#chicken-feed-guide"
  }];


  return (
    <section className="py-24 bg-muted">
      <div className="max-w-container mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 pb-6 border-b border-border reveal">
          <div>
            <span className="inline-block text-xs font-semibold uppercase tracking-widest text-primary mb-4">
              Industry Insights
            </span>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-foreground">
              Latest from Our Blog
            </h2>
          </div>
          <Link
            href="/blog"
            className="mt-4 md:mt-0 inline-flex items-center gap-2 bg-foreground text-background px-6 py-3 rounded-full text-sm font-semibold hover:bg-foreground/90 transition-colors">
            
            View All Posts
            <Icon name="ArrowUpRightIcon" size={16} />
          </Link>
        </div>

        {/* Blog Posts Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {posts?.map((post, index) =>
          <Link
            key={post?.id}
            href={post?.href}
            className="group reveal"
            style={{ transitionDelay: `${index * 100}ms` }}>
            
              <article className="bg-card rounded-organic overflow-hidden shadow-sm hover-lift h-full">
                {/* Image with Date Badge */}
                <div className="relative h-56 overflow-hidden">
                  <AppImage
                  src={post?.image}
                  alt={post?.alt}
                  className="w-full h-full object-cover image-scale" />
                
                  
                  {/* Date Badge */}
                  <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm rounded-lg px-3 py-2 text-center shadow-md">
                    <div className="text-lg font-bold text-foreground leading-none">
                      {post?.date?.split(' ')?.[1]?.replace(',', '')}
                    </div>
                    <div className="text-xs uppercase font-semibold text-muted-foreground">
                      {post?.date?.split(' ')?.[0]?.slice(0, 3)}
                    </div>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  {/* Category Pill */}
                  <span className="inline-block px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wider bg-primary/10 text-primary mb-3">
                    {post?.category}
                  </span>

                  <h3 className="text-xl font-bold font-serif text-foreground mb-3 leading-tight group-hover:text-primary transition-colors line-clamp-2">
                    {post?.title}
                  </h3>

                  <p className="text-sm text-muted-foreground mb-4 leading-relaxed line-clamp-3">
                    {post?.excerpt}
                  </p>

                  {/* Metadata */}
                  <div className="flex items-center gap-4 text-xs text-muted-foreground">
                    <div className="flex items-center gap-1">
                      <Icon name="ClockIcon" size={14} />
                      <span>{post?.readTime}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="CalendarIcon" size={14} />
                      <span>{post?.date}</span>
                    </div>
                  </div>

                  {/* Read More Link */}
                  <div className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary">
                    Read More
                    <Icon name="ArrowRightIcon" size={14} className="arrow-shift" />
                  </div>
                </div>
              </article>
            </Link>
          )}
        </div>
      </div>
    </section>
  );

}